const tasks = {
	title: "Oppgaver",
	new_task: "Ny oppgave",
	edit_task: "Rediger oppgave: {name}",
	view_task: "Vis oppgave: {name}",
	list_title: "Oppgaver",
	list_subtitle: "Håndter oppgave",
	create_title: "Opprett ny oppgave",
	update_title: "Endre oppgave",
	address_title: "Addresse",
	details_title: "Oppgave detaljer",
	id: "ID",
	name: "Tittel",
	description: "Beskrivelse",
	place: "Sted",
	instructor_id: "Instruktør",
	start_date: "Start Dato",
	start_time: "Start Tid",
	start_datetime: "Start Dato/Tid",
	end_date: "Slutt Dato",
	end_time: "Slutt Tid",
	end_datetime: "Slutt Dato/Tid",
	status: "Status",
	created_by: "Opprettet av",
};
export default tasks;